import type { CareerTrack, Tier } from '@backrs_ui/common-ui';

import { useRegisterAgentContext } from '@backrs_ui/grow-ui/src/agentContext/useRegisterAgentContext';

export const useAgentContext = (
  selectedTrack: Tier,
  careerTracks: CareerTrack[],
  userHasBlueprint: boolean,
) => {
  useRegisterAgentContext({
    kind: 'entity',
    description: 'The recommended minimum career track for the user',
    data: {
      selected_track: selectedTrack,
      has_blueprint: userHasBlueprint,
    },
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'Selected Track',
    description:
      'The career track tier recommended for this user based on their blueprint results. Shows the track name, description, and illustration.',
  });

  useRegisterAgentContext({
    kind: 'section',
    title: 'All Career Tracks',
    description:
      'Grid of all career track tiers for comparison — each card shows the track name, description, and actions to bookmark, share, or add as a task.',
  });

  useRegisterAgentContext({
    kind: 'list',
    description: 'All career track tiers displayed as cards for comparison',
    data: careerTracks,
  });
};
